module.exports = __webpack_public_path__ + "static/media/first.85418dec.jpeg";